module.exports = {
    __esModule: true,
    default: function anonymous(props
) {
var out='<div class="'+(props.styles.screen)+'" data-playable-hook="screen-block" data-playable-component> <canvas class="'+(props.styles.backgroundCanvas)+'" data-playable-hook="background-canvas"/></div>';return out;
} 
  };